import { useState } from "react";
import axios from "axios";

export default function LoginForm({ setToken, API_BASE_URL }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");


  const login = async () => {
    setLoading(true);
    setError("");
  
    try {
      const response = await axios.post(
        `${API_BASE_URL}/token/`,
        new URLSearchParams({ username, password }),
        { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
      );
  
      console.log("Full API Response:", response); // ✅ Debug response structure
  
      if (response.status === 200) {
        console.log("Response data:", response.data); // ✅ Check if it contains access_token
  
        const accessToken = response.data.access_token;
        if (!accessToken) {
          throw new Error("No access token returned from API");
        }
  
        console.log("Token received:", accessToken); // ✅ Debug received token
        setToken(accessToken);
        localStorage.setItem("token", accessToken);
  
        console.log("Token stored in localStorage:", localStorage.getItem("token")); // ✅ Confirm stored token
      } else {
        throw new Error(`Unexpected response status: ${response.status}`);
      }
    } catch (err) {
      console.error("Login Error:", err); // Log the entire error object
  
      if (err.response) {
        // ✅ More detailed error message if the server responded
        console.error("Server responded with:", err.response.status, err.response.statusText);
        console.error("Response headers:", err.response.headers);
        console.error("Response data:", err.response.data);
        setError(`Login failed: ${err.response.status} ${err.response.statusText} - ${JSON.stringify(err.response.data)}`);
      } else if (err.request) {
        // ✅ The request was made, but no response received
        console.error("No response received. Request details:", err.request);
        setError("No response from server. Please try again.");
      } else {
        // ✅ Something went wrong in setting up the request
        console.error("Error setting up the request:", err.message);
        setError(`Error: ${err.message}`);
      }
    }
  
  
    setLoading(false);
  };
  
  
  
  return (
    <div>
      <h2>Login</h2>
      {error && <p className="text-danger">{error}</p>}
      <input
        type="text"
        placeholder="Username"
        value={username}
        onChange={(e) => setUsername(e.target.value)}
      />
      <input
        type="password"
        placeholder="Password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
      />
      <button onClick={login} disabled={loading}>
        {loading ? "Logging in..." : "Login"}
      </button>
    </div>
  );
}
